import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getImpersonationStatus } from '@redux/selectors/ImpersonationSelector';
import { stopImpersonation } from '@redux/modules/impersonation';
import { LOGOUT } from '@redux/constants/ActionTypes';
import { setCurrentAgent } from '@redux/modules/agent';
import {
  getUserAvatar,
  getUserName,
  getUser,
  getLoadingState,
} from '@redux/selectors/UserSelector';

import agent from '@services/apiService';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Avatar from '@mui/material/Avatar';
import Settings from './Settings/SettingsModal';

const TopBar = () => {
  const dispatch = useDispatch();
  const history = useHistory(); // use for redirection
  const isLoading = useSelector(getLoadingState);
  const status = useSelector(getImpersonationStatus);
  const username = useSelector(getUserName);
  const user = useSelector(getUser);
  const userAvatar = useSelector(getUserAvatar);
  const logoutClicked = () => dispatch({ type: LOGOUT, payload: agent.Auth.Logout() });
  const profilePageClicked = () => {
    if (user) {
      const jsonBody = {
        action: 'select',
        where: {
          clause: [
            {
              name: 'UniqueID',
              value: user.UniqueID,
            },
          ],
        },
      };

      dispatch(setCurrentAgent(jsonBody)); // set agent to the current user/agent uniqueID
      history.push('/agent/view'); // redirect user to agent view page
    }
  };

  const impersonationHeader = (
    <span>
      {username}
      , logged in as
      {' '}
      <strong>
        {status.memberFullName}
        {' '}
        (
        {status.memberMlsId}
        )
      </strong>
    </span>
  );

  const handleStopClick = () => dispatch(stopImpersonation());

  if (isLoading) return null;
  return (
    <div className="ml-auto d-flex">
      <div className="header-icon text-muted">
        {status.ImpersonationActive ? (
          <>{impersonationHeader}</>
        ) : (
          <span>{username}</span>
        )}
      </div>
      {status.ImpersonationActive && (
        <div>
          <div
            aria-hidden="true"
            className="header-icon d-flex align-items-center justify-content-center"
            data-toggle="dropdown"
          >
            <Avatar
              sx={{
                width: 34,
                height: 34,
                color: '#333',
                bgcolor: 'var(--theme-primary)',
              }}
              alt={status.memberFullName}
            >
              <i className="fas fa-user-secret heartbeat" />
            </Avatar>
          </div>
          <div className="dropdown-menu dropdown-menu-animated dropdown-menu-extra">
            <div className="dropdown-item" onClick={handleStopClick}>
              <i className="far fa-stop-circle mr-2" />
              Stop Impersonating
            </div>
          </div>
        </div>
      )}
      <div>
        <div
          aria-hidden="true"
          className="header-icon d-flex align-items-center justify-content-center"
          data-toggle="dropdown"
        >
          <Avatar
            sx={{
              width: 34,
              height: 34,
              color: '#333',
              bgcolor: 'var(--theme-primary)',
            }}
            alt={username}
            src={userAvatar}
          />
        </div>
        <div className="dropdown-menu dropdown-menu-animated dropdown-lg dropdown-menu-extra">
          <div className="dropdown-header bg-trans-gradient d-flex flex-row py-4 rounded-top">
            <div className="d-flex flex-row align-items-center mt-1 mb-1 color-white">
              <span className="mr-2">
                <Avatar
                  sx={{
                    width: 52,
                    height: 52,
                    color: '#333',
                    bgcolor: 'var(--theme-primary)',
                  }}
                  alt={username}
                  src={userAvatar}
                />
              </span>
              <div className="info-card-text">
                <div className="fs-lg text-truncate text-truncate-lg">
                  {username}
                </div>
                <span className="text-truncate text-truncate-md opacity-80">
                  {user?.MemberEmail}
                </span>
              </div>
            </div>
          </div>
          <div className="dropdown-divider m-0" />
          <div className="dropdown-item" onClick={profilePageClicked}>
            <i className="fal fa-user mr-2" />
            <span>Profile</span>
          </div>
          <div
            className="dropdown-item"
            data-toggle="modal"
            data-target="#ImpersonationModal"
          >
            <i className="fal fa-user-secret mr-2" />
            <span>Impersonate</span>
          </div>
          <div className="dropdown-divider m-0" />
          <div className="dropdown-item" onClick={logoutClicked}>
            <i className="fal fa-sign-out-alt mr-2" />
            <span>Logout</span>
          </div>
        </div>
      </div>
      <Settings />
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="tooltip-logout-button" style={{ margin: 0 }}>Logout</Tooltip>}
      >
        <a
          className="header-icon waves-effect waves-themed"
          onClick={logoutClicked}
        >
          <i className="fal fa-sign-out-alt" />
        </a>
      </OverlayTrigger>
    </div>
  );
};

export default TopBar;
